import { Box } from "@mui/material";
import styled from "styled-components";

export const ProjectInfoFormStyled = styled(Box)`
  .grid-template {
    display: grid;
    grid-template-columns: 60% calc(40% - 16px);
    gap: 16px;
  }

  .grid-2 {
    display: grid;
    grid-template-columns: calc(66.66% - 5.34px) calc(33.33% - 8px); /* Subtract half the gap from each column */
    gap: 16px; /* Total gap between columns */
    padding-bottom: 24px;
  }

  .grid-3 {
    display: grid;
    grid-template-columns: calc(33.33% - 10.67px) calc(33.33% - 10.67px) calc(
        33.33% - 10.67px
      ); /* Adjust for the gap */
    gap: 16px; /* Total gap between columns */
    padding-bottom: 24px;
  }

  .flex {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .row-style {
    display: grid;
    gap: 16px;
  }

  .flex-grid {
    display: flex;
    gap: 16px;
  }

  .left-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .isNonBillable {
    width: fit-content;
  }
  .project-cont {
    display: flex;
    flex-direction: column;
    padding: 0px;
  }

  .schedulePadding {
    padding-bottom: 24px;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 10px;
    column-gap: 20px;
  }

  .checkbox-wrapper {
    display: flex;
    gap: 10px;
    margin-top: 30px;
    margin-left: 12px;

    .MuiFormControlLabel-root {
      height: 35px;
      border: 1px solid rgba(0, 0, 0, 0.23);
      border-radius: 4px;
      width: 50%;
      background-color: white;
    }
  }

  .totalService {
    background-color: blue;
  }

  .hr {
    border-bottom: 1px solid #dedafb;
    margin: 0;
  }
  .hr-2 {
    border: 1px solid #dedafb;
    margin: 16px 0;
  }
  .purpleBg {
    .MuiInputBase-root {
      background-color: #efedfd;
    }
    .Mui-disabled {
      -webkit-text-fill-color: #080425 !important;
    }
    .MuiInputBase-root.Mui-disabled {
      opacity: 1;
    }
  }

  .label {
    height: 23px;
    margin-bottom: 8px;
  }
`;
